<div mat-dialog-title>
  <div class="card-dlg-title">
    <p>Cadastro de incentivo</p>
    <mat-icon mat-dialog-close (click)="dialogRef.close()">close</mat-icon>
  </div>

</div>

<div class="card-dlg mat-typography">

  <div class="card-dlg__wrapper">

    <div class="card border-top card-title">
      <mat-form-field>
        <mat-label>Título do incentivo</mat-label>
        <input
          matInput
          maxlength="100"
          [formControl]="form.controls.title"
        />
        @if (form.controls.title.hasError('required')) {
          <mat-error>Título do incentivo é obrigatório</mat-error>
        }
      </mat-form-field>

    </div>

    <div class="card border-left">
      <p class="title">Página do aviso da pesquisa</p>

      <div class="card-form">

        @if (!form.controls.noticePageImg.value) {
          <img
            class="upload"
            src="assets/img/upload.png"
            alt="upload"
            (click)="noticeUploadFile.click()"
          />
        } @else {
          <img
            class="upload"
            [src]="form.controls.noticePageImg.value"
            alt="upload"
            (click)="noticeUploadFile.click()"
          />

          <img
            class="remove-img"
            src="assets/img/delete.png"
            alt="Delete img"
            title="Excluir imagem"
            (click)="form.controls.noticePageImg.setValue('')"
          />
        }
        <input
          type="file"
          #noticeUploadFile
          hidden
          (change)="resizeImage($event, 'notice')"
          accept="image/*"
        />

        <mat-form-field>
          <mat-label>Título</mat-label>
          <input
            matInput
            maxlength="100"
            [formControl]="form.controls.noticePageTile"
          />
          @if (form.controls.noticePageTile.hasError('required')) {
            <mat-error>Título do aviso é obrigatório</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Descrição</mat-label>
          <input
            matInput
            maxlength="100"
            [formControl]="form.controls.noticePageDescription"
          />
          @if (form.controls.noticePageDescription.hasError('required')) {
            <mat-error>Descrição do aviso é obrigatório</mat-error>
          }
        </mat-form-field>

      </div>
    </div>

    <div class="card border-left">
      <p class="title">Página do sorteado</p>

      <div class="card-form">

        @if (!form.controls.winnerPageImg.value) {
          <img
            class="upload"
            src="assets/img/upload.png"
            alt="upload"
            (click)="winnerUploadFile.click()"
          />
        } @else {
          <img
            class="upload"
            [src]="form.controls.winnerPageImg.value"
            alt="upload"
            (click)="winnerUploadFile.click()"
          />

          <img
            class="remove-img"
            src="assets/img/delete.png"
            alt="Delete img"
            title="Excluir imagem"
            (click)="form.controls.winnerPageImg.setValue('')"
          />
        }
        <input
          type="file"
          #winnerUploadFile
          hidden
          (change)="resizeImage($event, 'winner')"
          accept="image/*"
        />

        <mat-form-field>
          <mat-label>Título</mat-label>
          <input
            matInput
            maxlength="100"
            [formControl]="form.controls.winnerPageTitle"
          />
          @if (form.controls.winnerPageTitle.hasError('required')) {
            <mat-error>Título do sorteado é obrigatório</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Descrição</mat-label>
          <input
            matInput
            maxlength="100"
            [formControl]="form.controls.winnerPageDescription"
          />
          @if (form.controls.winnerPageDescription.hasError('required')) {
            <mat-error>Descrição do sorteado é obrigatório</mat-error>
          }
        </mat-form-field>

      </div>
    </div>

  </div>

  <div class="card-dlg__footer">
    <div class="card-dlg__footer__wrapper">
      <mat-form-field appearance="outline">
        <mat-label>Data inicial</mat-label>
        <input
          matInput
          [formControl]="form.controls.startDate"
          [matDatepicker]="pickerStart"
          [min]="minDate"
        />
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
        @if (form.controls.startDate.hasError('required') && form.controls.startDate.touched) {
          <mat-error>Data inicial é obrigatória</mat-error>
        }
        @if (form.controls.startDate.hasError('startDateInvalid')) {
          <mat-error>Data inicial não pode ser menor que a data atual</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Data final</mat-label>
        <input
          matInput
          [matDatepicker]="pickerEnd"
          [formControl]="form.controls.endDate"
          [min]="form.controls.startDate.value || minDate"
        />
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
        @if (form.controls.endDate.hasError('required') && form.controls.endDate.touched) {
          <mat-error>Data final é obrigatória</mat-error>
        }
        @if (form.controls.endDate.hasError('endDateInvalid')) {
          <mat-error>Data final não pode ser menor que a data inicial</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="card-dlg__footer__quantity">
      <mat-form-field>
        <mat-label>Quantidade de sorteio</mat-label>
        <input
          matInput
          placeholder="Digite a quantidade"
          maxlength="10"
          [formControl]="form.controls.numberOfDraws"
        />
        @if (form.controls.numberOfDraws.hasError('required')) {
          <mat-error>Quantidade de sorteio é obrigatório</mat-error>
        }
      </mat-form-field>
      <div class="toggle-container">
        <mat-slide-toggle [formControl]="form.controls.shifts" [disabled]="!hasShifts">
          {{ form.controls.shifts.value ? 'Sorteio por turno' : 'Sorteio por dia' }}
        </mat-slide-toggle>
        <ng-container *ngIf="!hasShifts">
          <mat-error style="display:block;margin-top:8px;">Esta unidade não possui turnos cadastrados.</mat-error>
        </ng-container>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="card-dlg__footer__wrapper">
      <button class="btn danger__no-bg" mat-dialog-close (click)="cancel()">Cancelar</button>
      <button class="btn danger" (click)="submit()">Salvar</button>
    </div>
  </div>

</div>
